<template>
    <div class="x_box A4">
        <div class="x_body">
            <ReportHeader></ReportHeader>
            <div class="card f_card">
                <div class="card-body">
                    <table class="table-print">
                        <tbody>
                            <tr>
                                <td>បានទទួលពី / Received form:</td>
                                <td rowspan="2" style="width: 220px;">
                                    <table style="width: 100%;">
                                        <tbody>
                                            <tr>
                                                <td style="width: 100px;">
                                                    <div>បង្កាន់ដៃលេខ</div>
                                                    <div>RECEIPT NO</div>
                                                </td>
                                                <td class="v-top" style="width: 10px;">:</td>
                                                <td class="text-right v-top">{{header.Num}}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div>កាលបរិច្ឆេទ</div> DATE</td>
                                                <td class="v-top">:</td>
                                                <td class="text-right v-top">{{$format(header.Date,'DD/MM/YYYY')}}</td>
                                            </tr>
                                            <tr>
                                                <td>PMT.METHOD</td>
                                                <td>:</td>
                                                <td class="text-right">{{header.AccountName}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <table class="table-none-bor">
                                        <tbody>
                                            <tr>
                                                <td style="width: 120px;">Customer</td>
                                                <td class="text-center" style="width: 10px;">:</td>
                                                <td>{{header.CustomerName}}</td>
                                            </tr>
                                            <tr>
                                                <td>Name</td>
                                                <td class="text-center" style="width: 15px;">:</td>
                                                <td>{{header.NameEng}}</td>
                                            </tr>
                                            <tr>
                                                <td>លេខអតប</td>
                                                <td class="text-center">:</td>
                                                <td>{{header.TinHead}}-{{header.VatTin}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table2">
                                <tbody>
                                    <tr>
                                        <td style="width: 120px;"><div>ចំនួនទឹកប្រាក់</div>Amount
                                        </td>
                                        <td class="v-top" style="width: 10px;">:</td>
                                        <td class="v-top">{{$money(header.Amount)}}</td>
                                    </tr>
                                    <tr>
                                        <td><div>គោលបំណង</div>Purpose</td>
                                        <td class="v-top">:</td>
                                        <td class="v-top">{{header.Description}}</td>
                                    </tr>
                                    <tr>
                                        <td><div>ជាអក្សរ</div>Amount in word
                                        </td>
                                        <td class="v-top">:</td>
                                        <td class="v-top" style="text-transform: capitalize;">{{header.TextAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td>Reference</td>
                                        <td class="v-top">:</td>
                                        <td class="v-top">{{invoinceNos}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="padding: 5px;">
                            <div>** សម្គាល់៖ បង្កាន់ដៃទទួលប្រាក់នេះត្រូវបានទទួលស្គាល់ប្រសិនបើមូលប្បទានបត្រត្រូវបានទទួលស្គាល់ដោយធនាគារ។</div>
                            <div style="font-style: italic;">Note: Payment is paid if cheque has been accepted and clear by bank.</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div style="display: flex; justify-content: space-between; margin: 0 50px;">
                        <div class="text-center">
                            <div>ហត្ថលេខា និងឈ្មោះអ្នកទទួលប្រាក់</div>
                            <div>RECEIVED BY:</div>
                        </div>
                        <div class="text-center">
                            <div>ហត្ថលេខា និងឈ្មោះអ្នកទទួលទូរទាត់</div>
                            <div>PAID BY:</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import { Sale } from '../../../shared/models/model';
import ReportHeader from '../../Components/ReportHeader';
export default {
    components: { ReportHeader },
    data: function(){
        return {
            header: {},
            lines: []
        }
    },
    created(){
        this.findById(this.$route.params.id);
    },
    methods: {
        findById(id){
            var loading = this.$loading.show();
            Sale.findReceiptPreview({ Id: id }).then(res => {
                this.header = res.Json.Header;
                this.lines = res.Json.Lines;
            }).finally(() => { loading.hide(); });
        },
        onApproval(){
            let id = this.$route.params.id;
            let loading = this.$loading.show();
            Sale.approveReceipt({ Id: id }).then(() => {
                this.$router.go(-1);
            }).finally(() => { loading.hide(); });
        },
        confirmDelete(){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    this.deleteById();
                }
            });
        },
        deleteById(){
            let id = this.$route.params.id;
            let loading = this.$loading.show();
            Sale.deleteReceipt({ Id: id }).then(() => {
                this.$router.go(-1);
            }).finally(() => { loading.hide(); });
        }
    },
    computed: {
        invoinceNos(){
            var res = [];
            this.lines.forEach(el => {
                if(el.TaxNum != undefined)
                res.push(el.TaxNum);
            });

            return res.join(',');
        }
    }
}
</script>
<style scoped>
    .table-print{
        width: 100%;
        border: 1px solid #000;
    }
    .table-print>tbody>tr>td{
        border: 1px solid #000;
        padding: 8px;
    }
    .table2{
        border: 1px solid #000;
        width: 100%;
    }
    .table2>tbody>tr>td{
        padding: 8px;
    }
</style>